import { ModalWindow, UIHeading2, UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ConfigurationModal.css';
import { IConfigurationFormatted } from '../../types/project';
import { DescriptionMarkup } from '../Description';

interface IConfigurationModalProps extends IConfigurationFormatted {
  projectName: string;
  phoneButton: React.ReactNode;
  open: boolean;
  onClose(): void;
}

export const ConfigurationModal: React.FC<IConfigurationModalProps> = ({
  open,
  onClose,
  projectName,
  name,
  price,
  description,
  phoneButton,
}) => {
  return (
    <ModalWindow
      fixed
      size="XS"
      open={open}
      onClose={onClose}
      title={`Конфигурация проекта «${projectName}»`}
      footer={phoneButton}
    >
      <div className={styles['content']}>
        <UIHeading2>{name}</UIHeading2>
        <div className={styles['price']}>
          <UIHeading3>{price}</UIHeading3>
        </div>
        {description && <DescriptionMarkup html={description} />}
      </div>
    </ModalWindow>
  );
};
